// services/analytics.service.ts
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private readonly measurementId: string;

  constructor(private configService: ConfigService) {
    this.measurementId = this.configService.getRequiredByPath<string>('googleAnalyticsId');
    this.initGoogleAnalytics();
  }

  private initGoogleAnalytics(): void {
    // Inicializa o dataLayer
    window.dataLayer = window.dataLayer || [];

    // Função gtag
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
// Adicione temporariamente no service:
    // Script do GA4
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    // Configuração básica
    window.gtag('js', new Date());
    window.gtag('config', this.measurementId, {
      send_page_view: true,
      page_title: document.title,
      page_location: window.location.href
    });
  }

  // Método para eventos gerais
  trackEvent(eventName: string, eventParams?: any): void {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
    }
  }

  // Método para tagueamento de botões
  trackButtonClick(buttonName: string, section?: string): void {
    this.trackEvent('button_click', {
      button_name: buttonName,
      section: section || 'general',
      page_path: window.location.pathname,
      timestamp: new Date().toISOString()
    });
  }

  // Método para tagueamento de ícones
  trackIconClick(iconName: string, location?: string): void {
    this.trackEvent('icon_click', {
      icon_name: iconName,
      location: location || 'header',
      page_path: window.location.pathname,
      timestamp: new Date().toISOString()
    });
  }

  // Método para rastreamento de navegação
  trackPageView(pageTitle: string, pagePath: string): void {
    window.gtag('event', 'page_view', {
      page_title: pageTitle,
      page_location: window.location.origin + pagePath,
      page_path: pagePath
    });
  }


}
